function normalizeInput(value) {
  if (value == null) return ''
  return String(value).trim()
}

function hasScheme(url) {
  return /^(https?:)?\/\//i.test(url)
}

/**
 * 将后端返回的资源路径规范化为可访问 URL。
 * - 支持完整地址：http(s)://...
 * - 支持协议相对地址：//cdn.xx.com/a.png
 * - 支持站内绝对/相对路径：/uploads/a.png、uploads/a.png、api/xxx
 */
export function resolveResourceUrl(rawPath) {
  const input = normalizeInput(rawPath)
  if (!input) return ''
  if (/^(data:|blob:)/i.test(input)) return input
  if (/^https?:\/\//i.test(input)) return input
  if (input.startsWith('//')) {
    const protocol = typeof window !== 'undefined' && window.location ? window.location.protocol : 'https:'
    return `${protocol}${input}`
  }
  if (typeof window === 'undefined' || !window.location || !window.location.origin) {
    return input
  }

  const base = window.location.origin
  if (input.startsWith('/')) {
    return `${base}${input}`
  }
  if (hasScheme(input)) {
    return input
  }
  return `${base}/${input}`
}

